import {batch, computed, signal} from "@preact/signals-react";


export const rawMatcherItems = signal(null)
export const rawMatcherImageSize = signal(1)
export const isLoadMoreItems = signal(false)
export const rawMatcherImageComparatorModalData = signal({})

// Computed
export const isRawMatcherLoading = computed(() => rawMatcherItems.value === null)
export const rawMatcherImageSizeValue = computed(() => [150, 200, 250][rawMatcherImageSize.value])

// Functions
export const clearRawMatcherSignals = () => batch(() => {
	rawMatcherItems.value = null
	rawMatcherImageSize.value = 1
	isLoadMoreItems.value = false
	rawMatcherImageComparatorModalData.value = {}
})